import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import {
  getCurrentUserApiCall,
  getFeedRelatedApi,
  loginApiCall
} from "../../api/api";
import { MainContext } from "../../context/mainContext";
import { Cookies } from "../../utils/cookies";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setIsAuth, setCurrentUser } = useContext(MainContext);

  const history = useHistory();

  const login = async (event) => {
    event.preventDefault();
    const { data } = await loginApiCall(username, password);
    if (data?.token) {
      getCurrentUser(data.token);
      Cookies.set("token", data.token, { path: "/" });
    }
  };

  const getCurrentUser = async (token) => {
    const { data } = await getCurrentUserApiCall(token);
    setCurrentUser(data);
    getRelatedFeeds(token);
  };

  const getRelatedFeeds = async (token) => {
    const { data } = await getFeedRelatedApi(token);
    data?.items.forEach((item) => {
      if (item?.strategy === "relatedVideos") {
        localStorage.getItem("relatedId", item.id);
      } else if (item?.strategy === "discover") {
        localStorage.getItem("discoverId", item.id);
      }
    });
    setIsAuth(true);
    history.push("/home");
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <form onSubmit={(e) => login(e)}>
          <label htmlFor="username">Kullanıcı Adı</label>
          <input
            id="username"
            value={username}
            required={true}
            onChange={(e) => setUsername(e.target.value)}
          />

          <label htmlFor="password">Şifre</label>
          <input
            id="password"
            type="password"
            value={password}
            required={true}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit" className="login-btn">
            Giriş Yap
          </button>
          <label className="sign-up">
            VOLE'ye üye değil misin? Hemen <span>üye ol</span>
          </label>
        </form>
      </div>
    </div>
  );
};

export default Login;
